import type { FunnelColor, FunnelDirection } from './types';

export function setAttrs(element: Element, attributes: Record<string, string | number>): void {
    Object.entries(attributes).forEach(([key, value]) => {
        element.setAttribute(key, String(value));
    });
}

export function removeAttrs(element: Element, ...attributes: string[]): void {
    attributes.forEach((attribute) => element.removeAttribute(attribute));
}

export function createSVGElement<K extends keyof SVGElementTagNameMap>(
    tagName: K,
    container?: Element,
    attributes?: Record<string, string | number>,
): SVGElementTagNameMap[K] {
    const el = document.createElementNS('http://www.w3.org/2000/svg', tagName) as SVGElementTagNameMap[K];
    if (attributes) setAttrs(el, attributes);
    if (container) container.appendChild(el);
    return el;
}

export function generateLegendBackground(color: FunnelColor, direction: FunnelDirection = 'horizontal'): string {
    if (typeof color === 'string') return `background-color: ${color}`;
    if (color.length === 1) return `background-color: ${color[0]}`;
    return `background-image: linear-gradient(${direction === 'horizontal' ? 'to right, ' : ''}${color.join(', ')})`;
}

const DEFAULT_COLORS = [
    '#FF4589', '#FF5050',
    '#05DF9D', '#4FF2FD',
    '#2D9CDB', '#A0BBFF',
    '#FFD76F', '#F2C94C',
    '#FF9A9A', '#FFB178',
];

/** Used only when a caller omits `data.colors` — the app's FunnelChart wrapper always supplies tokens instead. */
export function getDefaultColors(count: number): string[] {
    const pool = [...DEFAULT_COLORS];
    const colors: string[] = [];

    for (let i = 0; i < count; i++) {
        const index = Math.abs(Math.round(Math.random() * (pool.length - 1)));
        colors.push(pool[index]);
        pool.splice(index, 1);
    }

    return colors;
}
